import { render, staticRenderFns } from "./suppliersTable.vue?vue&type=template&id=5752664d&"
import script from "./suppliersTable.vue?vue&type=script&lang=js&"
export * from "./suppliersTable.vue?vue&type=script&lang=js&"
import style0 from "./suppliersTable.vue?vue&type=style&index=0&id=5752664d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports